import styled from 'styled-components';

// Two panes locked to the viewport by <Page fill>; each pane scrolls itself.
export const PageContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  flex: 1;
  min-height: 0;
`;

const Pane = styled.section`
  display: flex;
  flex-direction: column;
  min-width: 0;
  min-height: 0;
  overflow: hidden;
  background-color: ${({ theme }) => theme.cardBg};
  border: 1px solid ${({ theme }) => theme.border};
  border-radius: 12px;
`;

export const CommentListPanel = styled(Pane)<{ hasDetail: boolean }>`
  flex: ${({ hasDetail }) => (hasDetail ? '1 1 58%' : '1')};
`;

export const DetailPanel = styled(Pane)`
  flex: 0 0 42%;
  max-width: 520px;
`;

export const PaneScroll = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
`;

export const PaneFooter = styled.div`
  display: flex;
  justify-content: center;
  padding: 10px 12px;
  border-top: 1px solid ${({ theme }) => theme.border};
`;

export const PaneState = styled.div`
  display: flex;
  justify-content: center;
  padding: 24px;
`;

export const DetailBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px 18px 20px;
`;

export const DetailHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 12px 10px 18px;
  border-bottom: 1px solid ${({ theme }) => theme.border};
`;

export const PaneTitle = styled.h2`
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: ${({ theme }) => theme.textColor};
`;

export const VideoWrap = styled.div`
  width: 100%;
  max-width: 320px;
  align-self: center;
  border-radius: 12px;
  overflow: hidden;
`;

export const ReelThumb = styled.img`
  display: block;
  width: 40px;
  height: 60px;
  object-fit: cover;
  border-radius: 6px;
  background: ${({ theme }) => theme.surfaceRaised};
`;

export const UserCell = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
`;

export const UserName = styled.button<{ $strong?: boolean }>`
  padding: 0;
  border: 0;
  background: none;
  font-family: inherit;
  font-size: 13px;
  font-weight: ${({ $strong }) => ($strong ? 600 : 500)};
  color: ${({ theme }) => theme.textColor};
  text-align: left;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;

export const CommentText = styled.div`
  flex: 1;
  font-size: 13.5px;
  line-height: 1.4;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: ${({ theme }) => theme.textColor};
`;

export const CommentMeta = styled.div`
  font-size: 12px;
  color: ${({ theme }) => theme.mutedTextColor};
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
`;

export const ReelDescription = styled.p`
  margin: 0;
  font-size: 13.5px;
  line-height: 1.5;
  color: ${({ theme }) => theme.secondaryTextColor};
  overflow-wrap: anywhere;
`;

export const SectionTitle = styled.h3`
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: ${({ theme }) => theme.textColor};
`;

export const DetailCommentList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const DetailCommentRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 10px;
  padding: 8px 10px;
  border-radius: 8px;
  transition: background-color 0.15s ease;

  &:hover {
    background-color: ${({ theme }) => theme.surfaceHover};
  }
`;

export const DetailCommentBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;
  min-width: 0;
`;

export const DetailCommentHead = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
`;

export const DetailCommentText = styled.div`
  flex: 1;
  font-size: 13.5px;
  line-height: 1.4;
  color: ${({ theme }) => theme.secondaryTextColor};
  overflow-wrap: anywhere;
`;

export const ConfirmTitle = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: ${({ theme }) => theme.textColor};
`;

export const ConfirmText = styled.div`
  font-size: 14px;
  line-height: 1.5;
  color: ${({ theme }) => theme.secondaryTextColor};
`;
